import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@qirtaas/core/qirtaas.css'
import './styles.css'
import './library.css'
import './qirtaas-theme.css'
import './quran-insert.css'
import './markdown-import.css'
import './layout-fixes.css'
import './logo.css'
import './security.css'
import './share.css'
import AuthenticatedApp from './AuthenticatedApp'
import './redesign.css'

const savedTheme=window.localStorage.getItem('dawwin-theme')
document.documentElement.dataset.theme=savedTheme==='light'?'light':'dark'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthenticatedApp />
  </StrictMode>,
)
